import React from 'react';

import * as buttonConstants from '../buttonConstants';

import Button from '../Button';


function ConfirmationButton(props) {

    return (
        <Button
            {...props}
            flavor={buttonConstants.FLAVOR_CONFIRMATION}
        />
    );
}


ConfirmationButton.propTypes = {...Button.propTypes};

ConfirmationButton.defaultProps = {...Button.defaultProps};


export default ConfirmationButton;
